import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

export default function SuspectedBrandsTable(props) {
  const { finalData, heading } = props;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const headerBg = useColorModeValue("gray.50", "gray.700");
  const hoverBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const tableBg = useColorModeValue("white", "gray.800");
  const headerTextColor = useColorModeValue("gray.700", "gray.200");
  const rowTextColor = useColorModeValue("gray.800", "gray.100");
  const countTextColor = useColorModeValue("gray.700", "gray.200");
  const badgeBg = useColorModeValue("blue.50", "blue.900");
  const badgeColor = useColorModeValue("blue.700", "blue.200");

  return (
    <Box
      borderRadius="12px"
      overflow="hidden"
      border="1px solid"
      borderColor={borderColor}
      bg={tableBg}
      boxShadow="sm"
    >
      <Table variant="simple" size="md">
        <Thead bg={headerBg}>
          <Tr>
            <Th
              textAlign="center"
              fontSize="14px"
              fontWeight="600"
              color={headerTextColor}
              textTransform="none"
              letterSpacing="0.5px"
            >
              {heading}
            </Th>
            <Th
              textAlign="center"
              fontSize="14px"
              fontWeight="600"
              color={headerTextColor}
              textTransform="none"
              letterSpacing="0.5px"
            >
              Test Count
            </Th>
            <Th
              textAlign="center"
              fontSize="14px"
              fontWeight="600"
              color={headerTextColor}
              textTransform="none"
              letterSpacing="0.5px"
            >
              Genuine
            </Th>
            <Th
              textAlign="center"
              fontSize="14px"
              fontWeight="600"
              color={headerTextColor}
              textTransform="none"
              letterSpacing="0.5px"
            >
              Counterfeit
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {finalData.map((item, index) => (
            <Tr
              key={index}
              _hover={{ bg: hoverBg }}
              transition="background-color 0.2s ease"
            >
              <Td
                py="12px"
                px="16px"
                fontSize="14px"
                color={rowTextColor}
                textAlign="center"
                fontWeight="500"
                borderBottom="1px solid"
              borderColor={borderColor}
              >
                {item.brand}
              </Td>
              <Td py="12px" px="16px" textAlign="center" borderBottom="1px solid"
              borderColor={borderColor}>
                <Box
                  as="span"
                  bg={badgeBg}
                  color={badgeColor}
                  px="8px"
                  py="4px"
                  borderRadius="6px"
                  fontSize="13px"
                  fontWeight="600"
                >
                  {item.test}
                </Box>
              </Td>
              <Td py="12px" px="16px" textAlign="center" borderBottom="1px solid"
              borderColor={borderColor}>
                <Box
                  as="span"
                  bg="green.50"
                  color="green.600"
                  px="8px"
                  py="4px"
                  borderRadius="6px"
                  fontSize="13px"
                  fontWeight="600"
                >
                  {item.genuine}
                </Box>
              </Td>
              <Td py="12px" px="16px" textAlign="center" borderBottom="1px solid"
              borderColor={borderColor}>
                <Box
                  as="span"
                  bg="red.50"
                  color="red.600"
                  px="8px"
                  py="4px"
                  borderRadius="6px"
                  fontSize="13px"
                  fontWeight="600"
                >
                  {item.counterfeit}
                </Box>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
}
